const WORDS = ["Money Alwayz", "Kashae The God", "Paper Crown", "Secure the bag", "MAE", "Stream everywhere"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <div data-testid="editorial-marquee" className="relative -rotate-1 border-y border-[var(--line)] bg-[var(--bone)] py-5 text-[var(--ink)]">
      <div className="overflow-hidden">
        <div className="flex w-max animate-marquee">
          {row.map((w, i) => (
            <span key={i} className="flex items-center gap-8 pr-8 font-display text-4xl uppercase sm:text-6xl">
              {i % 2 ? <span className="font-serif-i normal-case">{w}</span> : w}
              <span className="text-3xl">$</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
